import { createContext, useContext } from 'react';

/**
 * Context that carries the active Form PF section key (e.g. '1b', '1c', '2b', '3a', '4a')
 * down to MultiFundRow so it can grey-out cells for funds that don't require the section.
 *
 * Updated by Sections/index.jsx per question row via SectionKeyContext.Provider.
 * Consumed by MultiFundRow.jsx via useSectionKey().
 */
export const SectionKeyContext = createContext(null);

export const useSectionKey = () => useContext(SectionKeyContext);
